import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-start" }
const _hoisted_2 = { class: "text-base font-bold" }

import { ArrowLeft } from 'lucide-vue-next';
    import { useRouter } from 'vue-router';
    import BaseButton from './BaseButton.vue';

    interface Props {
        label: string;
        to?: string;
        onClick?: () => void;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BackButton',
  props: {
    label: {},
    to: {},
    onClick: { type: Function }
  },
  setup(__props: any) {

    const props = __props;
    const router = useRouter();

    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        } else if (props.to) {
            router.push(props.to);
        } else {
            router.back();
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseButton, {
      onClick: handleClick,
      fill: "clear",
      color: "dark",
      expand: "block",
      size: "small",
      class: "flex justify-start gap-2 whitespace-nowrap text-black transition-colors hover:text-gray-700"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ArrowLeft), { class: "mr-3 h-5 w-5" }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1)
      ]),
      _: 1
    })
  ]))
}
}

})